<template>
    <div>

        <h5>Statut de course</h5>
        <div class="d-flex flex-row flex-wrap align-items-center justify-center gap-2">
            <b-button class="inline-submenu-btn with_icon" @click="changeCoureurAbandon"><span
                    v-if="!coureur.statut.abandon">Passer en Abandon</span><span v-else>Retirer
                    l'abandon</span></b-button>
            <b-button class="inline-submenu-btn with_icon" @click="changeCoureurDisqualifie"><span
                    v-if="!coureur.statut.disqualifie">Passer en
                    Disqualifié</span><span v-else>Retirer la disqualification</span></b-button>
        </div>

    </div>
</template>

<script>
import axios from "axios";
export default {
    props: {
        coureur: {
            type: Object,
            required: true
        }
    },
    methods: {

        // Methode spécifique au PC course pour changer le statut d'abandon d'un coureur
        changeCoureurAbandon() {

            const nouvelle_valeur = this.coureur.statut.abandon ? "N" : "O";
            let _this = this;
            let data = {
                id_module: this.$store.state.module.id,
                id_live: this.coureur.id_live,
                dossard: this.coureur.identite.dossard,
                type_bouton: "abandon",
                nouvelle_valeur: nouvelle_valeur,
            };

            axios.post(this.$store.state.base_url + "/pc_course/statut_coureur/post.php", data).then(function (response) {
                _this.$emit('statut-coureur-changed');
            });
        },
        // Methode spécifique au PC course pour changer le statut de disqualification d'un coureur
        changeCoureurDisqualifie() {
            const nouvelle_valeur = this.coureur.statut.disqualifie ? "N" : "O";
            let _this = this;
            let data = {
                id_module: this.$store.state.module.id,
                id_live: this.coureur.id_live,
                dossard: this.coureur.identite.dossard,
                type_bouton: "disqualifie",
                nouvelle_valeur: nouvelle_valeur,
            };

            axios.post(this.$store.state.base_url + "/pc_course/statut_coureur/post.php", data).then(function (response) {
                _this.$emit('statut-coureur-changed');
            });
        },

    }
}
</script>

<style lang="scss" scoped></style>